const SET_REPORT_RESULTS = (state, payload) => {
  state.results = payload;
}

export default {
  SET_REPORT_RESULTS
}